import {
  faCheck as faCheckRegular,
  faCopy as faCopyRegular,
} from "@fortawesome/pro-regular-svg-icons";
import { faCheck, faCopy } from "@fortawesome/pro-solid-svg-icons";
import { Button, Icon } from "@intility/bifrost-react";
import { useState } from "react";

export function CopyButton({
  value,
  style,
  small = true,
  regularIcon = false,
  children,
}: {
  value: string;
  style?: React.CSSProperties;
  /** Small button (default). Pass `false` for the regular size. */
  small?: boolean;
  /** Use the regular-weight icons instead of the solid ones (default). */
  regularIcon?: boolean;
  /** Visible label next to the icon. Without it the button is icon-only. */
  children?: React.ReactNode;
}) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <Button
      variant="flat"
      small={small}
      onClick={handleCopy}
      aria-label={children ? undefined : "Copy to clipboard"}
      style={style}
    >
      <Icon
        icon={
          regularIcon
            ? copied
              ? faCheckRegular
              : faCopyRegular
            : copied
              ? faCheck
              : faCopy
        }
        marginRight={Boolean(children)}
      />
      {children}
    </Button>
  );
}
